import React from 'react';

import { SPACE_PERMISSIONS_SETTINGS } from '@confluence/named-routes/entry-points/routes.ts';
import { useRouteName } from '@confluence/route-manager/entry-points/RouteState.ts';
import { FeedbackCollectorButton } from '@confluence/space-roles/entry-points/FeedbackCollector.tsx';

export const SpaceAccessFeedbackButton = () => {
	const isSpacePermissionsPageArgs = {
		selector: (routeName: string | undefined) => {
			if (!routeName) {
				return false;
			}
			return routeName === SPACE_PERMISSIONS_SETTINGS.name;
		},
	};
	const isSpacePermissionsPage = useRouteName(isSpacePermissionsPageArgs);

	if (!isSpacePermissionsPage) {
		return null;
	}

	return <FeedbackCollectorButton source="Space Access" />;
};
